/**
 * Locale-aware date/number formatting. Reads the active UI language from
 * i18next so dates/numbers follow the per-user UI language instead of a
 * hardcoded 'fr-FR'. Use these instead of `.toLocaleDateString('fr-FR')` etc.
 *
 * These are plain functions (not hooks) so they work in components, module
 * helpers, and non-React code alike. They read i18n.language at call time, so
 * they reflect a language switch on the next render.
 */
import i18n from './index';

/** BCP-47 locale for the active UI language (fr → 'fr-FR', en → 'en-GB'). */
export function activeLocale(): string {
  return (i18n.language || 'fr').startsWith('en') ? 'en-GB' : 'fr-FR';
}

export function formatDate(
  value: string | number | Date,
  options?: Intl.DateTimeFormatOptions,
): string {
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString(activeLocale(), options);
}

export function formatDateTime(
  value: string | number | Date,
  options?: Intl.DateTimeFormatOptions,
): string {
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleString(activeLocale(), options);
}

export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return value.toLocaleString(activeLocale(), options);
}
